import React from 'react'

function ColumnDivider(props){

  return (
    <div className="ColumnDivider">{props.children}</div>
  )
}

export default ColumnDivider


// WEBPACK FOOTER //
// ./components/layout/column-divider.js